import { Route } from 'react-router-dom'
import { GalleryStudioLayout } from './layouts/GalleryStudioLayout'
import { GalleryStudioScreen } from './screens/GalleryStudioScreen'

/**
 * Legacy Gallery Studio route (2D pattern-editor shell) — used to own
 * `/galleries/:galleryId/studio` before the `gallery-studio-3d` promotion
 * from `studio-next` took that path over. Re-mounted at `-classic` (see
 * `album/routes.tsx`) for side-by-side comparison against the new editor on
 * the same gallery.
 *
 * /galleries/:galleryId/studio-classic
 */
export const galleryStudioRouteElements = (
  <Route path='galleries/:galleryId/studio-classic' element={<GalleryStudioLayout />}>
    <Route index element={<GalleryStudioScreen />} />
  </Route>
)
